import {createEntityAdapter, EntityAdapter} from '@ngrx/entity';
import {SongEntity, SongState} from '@spout/any-shared/models';

export const songAdapter: EntityAdapter<SongEntity> = createEntityAdapter<SongEntity>();

export const initialSongState: SongState = songAdapter.getInitialState({
  // additional entity state properties
});
